import {EventConstants} from 'constants/EventConstants';
import HomeDashboardDAO from 'home-dashboard/HomeDashboardDAO';
import AppDispatcher from 'lib/Dispatcher';

const HomeDashboardActions = {
  fetchEntryReviewSummary(): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY,
    });

    HomeDashboardDAO.fetchEntryReviewSummary()
      .done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY_COMPLETED,
          entryReviewSummary: response,
        });
      })
      .fail((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY_FAILED,
          error: response,
        });
      });
  },

  fetchWorksheetReviewSummary(): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY,
    });

    HomeDashboardDAO.fetchWorksheetReviewSummary()
      .done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY_COMPLETED,
          worksheetReviewSummary: response,
        });
      })
      .fail((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY_FAILED,
          error: response,
        });
      });
  },

  openSearchOrgModal(): void {
    AppDispatcher.dispatch({actionType: EventConstants.OPEN_SEARCH_ORG_MODAL});
  },
  closeSearchOrgModal(): void {
    AppDispatcher.dispatch({actionType: EventConstants.CLOSE_SEARCH_ORG_MODAL});
  },
  closeCRISPRModal(): void {
    AppDispatcher.dispatch({actionType: EventConstants.CLOSE_CRISPR_MODAL});
  },
};

export default HomeDashboardActions;
